@import "../../../../../styles/variables.scss";

.conversational-search-mobile-header {
  align-items: center;
  background-color: $svs-100-background;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  max-height: 64px;
  padding: 16px;
  padding-right: 8px;

  @media (min-width: $uiaas-tablet) {
    display: none;
  }

  &__text {
    font-size: 22px;
    line-height: 30px;
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__action-items {
    display: flex;

    qds-button {
      margin-left: 8px;
    }
  }
}
